import React from 'react';

/**
 * Icone de Fechar
 * @returns {ReactComponentElement} 
 */
const CloseIcon = ({ fill, className }) => {
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" width="48" height="49" viewBox="0 0 48 49" fill="none">
            <g filter="url(#filter0_d_1219_9403)">
                <path d="M23.0812 44.791C35.2375 44.791 45.0921 34.9363 45.0921 22.7801C45.0921 10.6238 35.2375 0.769165 23.0812 0.769165C10.9249 0.769165 1.07031 10.6238 1.07031 22.7801C1.07031 34.9363 10.9249 44.791 23.0812 44.791Z" fill="transparent"/>
            </g>
            <path fillRule="evenodd" clipRule="evenodd" d="M30.9296 17.4219C31.6173 16.7342 31.6173 15.6193 30.9296 14.9316C30.242 14.244 29.127 14.244 28.4394 14.9316L23.0812 20.2898L17.7231 14.9316C17.0354 14.244 15.9205 14.244 15.2328 14.9316C14.5452 15.6193 14.5452 16.7342 15.2328 17.4219L20.591 22.78L15.2328 28.1382C14.5452 28.8258 14.5452 29.9408 15.2328 30.6284C15.9205 31.3161 17.0354 31.3161 17.7231 30.6284L23.0812 25.2703L28.4394 30.6284C29.127 31.3161 30.242 31.3161 30.9296 30.6284C31.6173 29.9408 31.6173 28.8258 30.9296 28.1382L25.5715 22.78L30.9296 17.4219Z" fill={fill ? fill : "#FFF"}/>
            <defs>
                <filter id="filter0_d_1219_9403" x="0.189877" y="0.769165" width="47.5435" height="47.5435" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                <feOffset dx="0.880436" dy="1.76087"/>
                <feGaussianBlur stdDeviation="0.880436"/>
                <feComposite in2="hardAlpha" operator="out"/>
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1219_9403"/>
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1219_9403" result="shape"/>
                </filter>
            </defs>
        </svg>
    );
}

export default CloseIcon;